import React, { useEffect } from "react";
import { observer } from "mobx-react";
import YTDChart from "./sections/EmissionSummary/YTDChart.js";
import OGGEbyCategory from "./sections/EmissionSummary/OGGEbyCategory.js";
import OGGEbyPeriod from "./sections/EmissionSummary/OGGEbyPeriod.js";
import MyEmissionHotpots from "./sections/EmissionSummary/MyEmissionHotpots.js";
import styles from "./styles/dashboard.module.css";
import DashboardHeader from "./components/DashboardHeader.js";
import dashboardStore from "./store/dashboardStore.js";
import { PageSwitch } from "./components/PageSwitch.js";
import { AETracking } from "./sections/GHGPerformance/AETracking/AETracking.js";
import { Intensity } from "./sections/GHGPerformance/Intensity/Intensity.js";
import { SwitchPageWarningModal } from "./modals/SwitchPageWarningModal.js";

const DashboardContainerV4 = observer(() => {
  const store = dashboardStore;
  return (
    <div className={styles.container}>
      <PageSwitch />
      <DashboardHeader />
      {/* main */}
      {store.selectedDashboardPage === 0 ? (
        <div className={styles.main}>
          <YTDChart />
          <OGGEbyPeriod />
          <OGGEbyCategory />
          <MyEmissionHotpots />
        </div>
      ) : (
        <div className={styles.GHGmain}>
          {store.selectedSubTab === 0 ? <AETracking /> : <Intensity />}
        </div>
      )}

      {store.showDashboardWarningModal === true ? (
        <SwitchPageWarningModal />
      ) : null}
    </div>
  );
});

export default DashboardContainerV4;
